import React from "react";
import styles from "./styles.module.scss";
import { capitalize } from "@intelligentlilli/lilli-utils";
import PrimaryButton from "../PrimaryButton";
import { toSnakeCase } from "Services/Utils/toSnakeCase";

const DashboardTab = ({ title, selectedTab, setSelectedTab, onTrack }) => {
  const isSelected = selectedTab === title;
  return (
    <PrimaryButton
      className={isSelected ? styles.is_selected : styles.dashboard_tab}
      onClick={() => {
        onTrack({ tab: toSnakeCase(title) });
        setSelectedTab(title);
      }}
    >
      {capitalize(title)}
    </PrimaryButton>
  );
};

export default DashboardTab;
